<template>
    <section class="hero is-medium is-primary is-bold">
        <div class="hero-body">
            <div class="container">
                <p class="title">
                    Portal do Cliente
                </p>
                <span class="subtitle">
                    Bem-vindo, {{ usuario.nome }}
                </span>
                <b-message>
                    <b>{{ usuario.pessoa.nome }}</b>
                    <br/>
                    <p>{{ usuario.pessoa.razaosocial }}</p>
                    <address>
                        {{ usuario.pessoa.endereco }}
                        {{ usuario.pessoa.numero }}
                        <br/>
                        {{ usuario.pessoa.complemento }}
                        {{ usuario.pessoa.bairro }}
                        {{ usuario.pessoa.cidade }}
                    </address>
                </b-message>
                <p>Dados financeiros:</p>
                <b-message>
                    <p>{{ usuario.pessoa.razaoSocial }}</p>
                    <p class="is-size-7">CNPJ: <b>{{ usuario.pessoa.cnpj }}</b></p>
                    <p class="is-size-7">Inscrição Estadual: <b>{{ usuario.pessoa.inscricaoEstadual }}</b></p>
                    <p class="is-size-7">Inscrição Municipal: <b>{{ usuario.pessoa.inscricaoMunicipal }}</b></p>
                </b-message>
            </div>
        </div>
    </section>
</template>

<script>
    import { mapState } from 'vuex'

    export default {
        name: 'home',
        computed: {
            ...mapState([
                'usuario'
            ])
        }
    }
</script>
